export default {
    "title": "Albaranes / {{client}}",
    "description": "Listado de albaranes con descarga en formato PDF",
    "filters": {
        "deliveryNotesNumber": "Número de albarán"
    },
    "deliveryNotesHeader": "<0>{{count}}</0> albaranes",
    "deliveryNotesTableColumns": {
        "date": "Fecha de albarán",
        "order_id": "Número de pedido",
        "client_id": "ID de cliente",
        "delivery_id": "Número de albarán",
        "invoice_id": "Número de factura",
        "invoice_date": "Fecha de factura",
        "pdf_order_download": "Descargar albarán (PDF)",
        "pdf_packing_list_download": "Descargar Packing List (XLS)"
    },
    "nameCollection": "albaranes"
};